export enum PeriodType {
    DAILY = 1,
    WEEKLY = 2,
    MONTHLY = 3,
    YEARLY = 4,
    CUSTOM = 5
}
